export default {
    API_BASE: 'http://localhost:3010/api/akiramm/'
}